import ProductCanvasEditor from "./ProductCanvasEditor";

export default ProductCanvasEditor;
